module.exports = __webpack_public_path__ + "img/screenBackLight.5772212b.png";